import { CheckboxField } from '@monorepo/shared/componentsV2/fields/CheckboxField';
import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import React from 'react';
import { useField } from 'react-final-form';
import { ModalFieldWrapper } from '../../styled';

type EditIsRequiredFieldProps = {
  isInspectionDate?: boolean;
  prefix?: string;
};

export function EditIsRequiredField({
  isInspectionDate,
  prefix,
}: EditIsRequiredFieldProps) {
  const fieldName = getFieldNameWithPrefix('isRequired', prefix);
  const {
    input: { value: isRequired },
  } = useField<boolean>(fieldName);

  // if the inspection date is not marked as required (e.g. via admin panel), let users fix that
  const shouldBeDisabled = isInspectionDate && isRequired;

  return (
    <ModalFieldWrapper>
      <CheckboxField
        name={fieldName}
        label="Required"
        disabled={shouldBeDisabled}
        focusableWhenDisabled
        tooltip={
          shouldBeDisabled
            ? 'To mark this as not required, choose another field to be the inspection date.'
            : ''
        }
      />
    </ModalFieldWrapper>
  );
}
